import { App as F7App, View } from 'framework7-react';
import routes from './routes/appRoutes';
import { useAuth } from './hooks/useAuth';
import './App.css';
import { SplashScreen } from '@capacitor/splash-screen';
import { useEffect } from 'react';
import AuthDebug from './components/AuthDebug';

function App() {
  const { loadingAuth, isAuthenticated } = useAuth(true);

  useEffect(() => {
    SplashScreen.hide().catch(() => {
      // ignore errors in web builds
    });
  }, []);

  if (loadingAuth) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <F7App name="DealSaver" theme="auto" routes={routes}>
      <View id="main-view" main url={isAuthenticated ? '/support' : '/'} className="safe-areas" />
      {import.meta.env.DEV && <AuthDebug />}
    </F7App>
  );
}

export default App;
